import { Table, TablePaginationConfig } from 'antd';
import { SorterResult } from 'antd/es/table/interface';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { useSteeringTableColumns } from 'business/steering/pages/table-page/components/steering-table/hooks/use-steering-table-columns';
import { SteeringDataFields } from 'business/steering/pages/table-page/types';
import { GetSteeringDataQuery } from 'generated/graphql';
import { useMediaType } from 'technical/media/hooks';

interface SteeringTableProps {
  data?: GetSteeringDataQuery['parameter_ring'];
  loading: boolean;
  pagination: TablePaginationConfig;
  onChange?: (
    pagination: TablePaginationConfig,
    _: unknown,
    sorter:
      | SorterResult<SteeringDataFields>
      | SorterResult<SteeringDataFields>[],
  ) => void;
  onEditionClick: (id: string | null) => void;
}

export const SteeringTable = ({
  data = [],
  loading,
  pagination,
  onChange,
  onEditionClick,
}: SteeringTableProps) => {
  const { isMobile } = useMediaType();
  const { currentConstructionSite } = useAppContext();
  const isArticulated = currentConstructionSite?.isArticulated;
  const columns = useSteeringTableColumns(onEditionClick, isArticulated);

  return (
    <Table
      bordered
      scroll={{ x: 'max-content' }}
      // 90 is the value of src/business/App.scss - $header-height
      sticky={{ offsetHeader: isMobile ? 0 : 90 }}
      size={'small'}
      columns={columns}
      dataSource={data}
      pagination={pagination}
      loading={loading}
      rowKey={(record) => record.id}
      onChange={onChange}
    />
  );
};
